import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Col, Row, Card, Form, Button, Spinner, Container, Navbar, Nav, InputGroup, Alert} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactMarkdown from 'react-markdown';
import RenderizarProduto from '../Utils/RenderizarProduto';
import RenderizarFoto from '../Utils/RenderizarFoto';
import ImageCropper from '../Utils/ImageCropper';
import BotaoFinalizar from './BotaoFinalizar';
import FormaDeEnvio from './FormaDeEnvio';
import { useProvider, Toast } from '../../context/MenuProvider';


const CarrinhoPedido = ({crud, Toast, empresa, queryParams}) => {
    const navigate = useNavigate();
    const { post, loading } = crud;
    const [itens, setItens] = useState([]);
    const [desconto, setDesconto] = useState(0);
    const [endereco, setEndereco] = useState(null);
    const [pagamento, setPagamento] = useState(null);
    const [total, setTotal] = useState(0);
    const [subTotal, setSubTotal] = useState(0);
    const {
      buscarDadosPorId,
      salvarDados,
      navigateTo,
    } = useProvider();
    
    // useEffect(() => {
    //   // Inicialize o AOS para as animações, caso esteja usando isso
    //   AOS.init({
    //     duration: 1000,
    //     easing: "ease-in-out",
    //     once: true,
    //     mirror: false
    //   });
    // }, []);
    
    const removerItem = async (item) => {
      try {
        const itensAtualizados = itens.filter(x => x.produto.id !== item.produto.id);
        
        const response = await buscarSacola('local_registros','sacola');
        let sacola = response ? response : { itens: [] };
        
        const atualizado = { ...sacola, itens: itensAtualizados };
        await salvarDados("local_registros",{
          ...atualizado,
          id:"sacola"
        });
        buscarSacola();
      } catch (err) {
        console.error('Erro ao remover item:', err);
      }
    };
    
    const buscarSacola = async () => {
        try {
          const response = await buscarDadosPorId('local_registros', 'sacola');
          
          if (response) {
            const sacola = response || {};
            const itens = sacola.itens.filter(x => x.produto.empresa === empresa.id) || [];
            const quantidade = itens.reduce((acc, x) => acc + x.quantidade, 0);
            const total = itens.reduce((acc, x) => acc + (x.produto.preco_unitario * x.quantidade), 0);
            const taxa_entrega = sacola.endereco?.is_entrega?parseFloat(sacola.endereco?.taxa||0):0;
    
            //setQuantidade(quantidade);
            setItens(itens);
            setSubTotal(total);
            setTotal(total - parseFloat(sacola.desconto||0) + taxa_entrega);
            setEndereco(sacola.endereco);
            setPagamento(sacola.pagamento);
            setDesconto(sacola.desconto);
          }
        } catch (err) {
          console.error('Erro ao buscar sacola:', err);
        }
    };
    
    useEffect(() => {
      buscarSacola();
    }, [empresa]);
    
    const formatTelefone = (telefone) => {
      telefone = telefone.replace(/\D/g, '');
      if (!telefone) return '';
      return `+55${telefone}`;
    }
  
    const labelPagamento=()=>{
      switch(pagamento?.tipo){
        case 'dinheiro':
          return `Dinheiro${pagamento?.troco>0?`\ntraz ${parseFloat(pagamento?.troco||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} de troco, tenho ${parseFloat(pagamento?.troco_para||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`:""}`;
        case 'cartao':
          return `Cartão\ntraz maquininha`;
        case 'pix':
          return `Pix`;
        case 'online':
          return `Online`;
      }
    }
    const carrinho = () => {
      let mensagem = `Olá! ${empresa?.nome_da_loja}\nGostaria de comprar esses produtos 🛍️:\n\n`;
    
      itens.forEach(item => {
        mensagem += `${item.quantidade}x ${item.produto.nome_do_produto} - ${parseFloat(item.produto.preco_unitario * item.quantidade).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}\n${item.observacoes?`> Obs: _${item.observacoes}_ \n`:''}`;
      });
      if(desconto >0) mensagem +=`\nDesconto de ${parseFloat(total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`
      if(endereco?.taxa >0 && endereco?.is_entrega) mensagem +=`\nEntrega padrão ${parseFloat(endereco?.taxa||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
    
      mensagem += `\n\n*Valor Total: ${parseFloat(total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}*`;
      mensagem += `\nPagamento: ${labelPagamento()}`;
      if(endereco?.is_entrega){
        mensagem+=`\nEndereço de entrega:`;
        mensagem+=`\n${endereco?.rua}, n°${endereco?.numero}, ${endereco?.bairro}, ${endereco?.cidade} - ${endereco?.uf}`;
      }else{
        mensagem+=`\nRetirada no local`
      }
      mensagem+=`\n\nMuito Obrigado! 😉`
      const texto = encodeURIComponent(mensagem);
      const url = `whatsapp://send?${formatTelefone(empresa?.telefone_whatsapp) ? `phone=${formatTelefone(empresa?.telefone_whatsapp)}&` : ""}text=${texto}`;
      window.open(url, '_blank', 'noopener,noreferrer');
    };
    
    
    const botao = {
      onClick:carrinho, 
      text:'Enviar pedido'
    }
    
    useEffect(()=>{
      const vTotal = parseFloat(total||0);
      const troco_para = parseFloat(pagamento?.troco_para || 0)
      setPagamento((prevItem)=>({
        ...prevItem,
        troco: troco_para > vTotal?troco_para - vTotal:0
      }))
    },[pagamento])
  
    return (
        <>
          <BotaoFinalizar itens={itens} desconto={desconto} total={total} enabled={Boolean(pagamento?.tipo?.trim() && !loading && itens.length)} botao={botao}/>
          <div className="mt-3" style={{ paddingBottom: '200px' }}>
            <FormaDeEnvio />
            <div className="border-dashed-bottom mb-2">
              Itens do pedido
            </div>
            <div className="list-group mt-3">
                    {itens.length > 0 ? (
                      itens.map((x, index) => (
                        <div>
                          <RenderizarProduto
                            key={x.produto.id}
                            lm="mb-1"
                            src={x.produto.foto_do_produto}
                            text1={`${x.quantidade}x ${x.produto.nome_do_produto}`}
                            titulo={parseFloat(x.produto.preco_unitario*x.quantidade).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            text2={(
                              <>
                                <div className="border-top pt-1">
                                  <Row>
                                    <Col></Col>
                                    <Col xs="auto">
                                      <InputGroup>
                                        <Button variant="secondary" onClick={()=>navigate(`?p=adicionar-produto&id=${x.produto.id}`)} className="btn-sm">Editar</Button>
                                        <Button variant="danger" onClick={()=>removerItem(x)} className="btn-sm">Remover</Button>
                                      </InputGroup>
                                    </Col>
                                  </Row>
                                </div>
                              </>
                            )}
                            extra={(<>
                              {x.observacoes && (
                                <div className="text-muted small border-top py-1 mt-1">
                                  Obs: <i>{x.observacoes}</i>
                                </div>
                              )}
                            </>)}
                          />
                        </div>
                      ))
                    ) : (
                      !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                </div>
            <div className="text-center mt-3" >
              <Button onClick={()=>navigate('?p=')} className="btn-sm px-5" variant="secondary">Adicionar mais itens</Button>
            </div>
            <div className="border-dashed-top pt-2 mt-4" >
              <Row>
                <Col>SubTotal</Col>
                <Col xs="auto">{parseFloat(subTotal||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
              </Row>
              <Row>
                <Col>Entrega padrão</Col>
                <Col xs="auto">{parseFloat(endereco?.taxa||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
              </Row>
              <Row>
                <Col>Desconto</Col>
                <Col xs="auto">{parseFloat(desconto||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
              </Row>
              <Row>
                <Col><b>Total</b></Col>
                <Col xs="auto">
                  <b>
                    {parseFloat(total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </b>
                </Col>
              </Row>
            </div>
            <div className="border-dashed-top pt-1 mt-4 mb-3">
              <Form.Group controlId="formPagamento" className="">
                {(pagamento?.tipo==="dinheiro" || pagamento?.tipo === "cartao") && (
                <div className="small text-muted">Pagamento na entrega</div>
              )}
                <InputGroup>
                  <span className="input-group-text">Pagamento</span>
                  <Form.Control 
                    as="select" 
                    value={pagamento?.tipo} 
                    onChange={(e) => setPagamento((prevItem)=>({
                      ...prevItem,
                      tipo:e.target.value
                    }))}
                  >
                    <option value="" selected disabled>Selecione uma opção</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="cartao">Cartão (Maquininha)</option>
                    <option value="pix">Pix</option>
                    <option value="online">Online</option>
                  </Form.Control>
                </InputGroup>
              </Form.Group>
              {pagamento?.tipo === "dinheiro" && (
                <Form.Group controlId="formTroco" className="mt-3">
                  <InputGroup>
                    <span className="input-group-text">Troco para R$</span>
                    <Form.Control 
                      type="number" 
                      value={pagamento?.troco_para} 
                      onChange={(e) => setPagamento((prevItem)=>({
                          ...prevItem,
                          troco_para:e.target.value
                      }))}
                      onBlur={(e) => setPagamento((prevItem)=>({
                          ...prevItem,
                          troco_para: parseFloat(e.target.value||0) <=parseFloat(total||0)?parseFloat(total||0).toFixed(2):parseFloat(e.target.value||0).toFixed(2)
                      }))}
                    />
                    <span className="input-group-text">Troco {parseFloat(pagamento?.troco||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                  </InputGroup>
                </Form.Group>
              )}
            </div>
            <div className="border-dashed-top pt-1 mb-3">
              {endereco?.is_entrega?(
                <>
                  <div>
                    {`Endereço de ${endereco?.is_entrega?"entrega":"retirada"}:`}
                  </div>
                  <div>
                    {`${endereco?.rua}, n°${endereco?.numero}, bairro ${endereco?.bairro}, ${endereco?.cidade} - ${endereco?.uf}`}
                  </div>
                  {endereco?.complemento && (
                    <div>Complemento: {endereco?.complemento}</div>
                  )}
                </>
              ):(
                <></>
              )}
            </div>
          </div>
        </>
    );
};

export default CarrinhoPedido